import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import type { FC } from 'react';

/** Page chrome while subscription entitlements load (guard / redirects). */
export const SubscriptionPermissionsPageSkeleton: FC = () => (
  <Box
    p={3}
    display="flex"
    flexDirection="column"
    style={{ gap: 16, minHeight: '100%', boxSizing: 'border-box' }}
  >
    <Box display="flex" flexDirection="column" style={{ gap: 8 }}>
      <Skeleton variant="text" width={180} height={18} />
      <Skeleton variant="text" width="35%" height={32} />
      <Skeleton variant="text" width="50%" height={20} />
    </Box>
    <Box display="flex" style={{ gap: 12, flexWrap: 'wrap' }}>
      <Skeleton variant="rectangular" height={88} style={{ borderRadius: 8, flex: '1 1 160px' }} />
      <Skeleton variant="rectangular" height={88} style={{ borderRadius: 8, flex: '1 1 160px' }} />
      <Skeleton variant="rectangular" height={88} style={{ borderRadius: 8, flex: '1 1 160px' }} />
      <Skeleton variant="rectangular" height={88} style={{ borderRadius: 8, flex: '1 1 160px' }} />
    </Box>
    <Skeleton variant="rectangular" height={320} style={{ borderRadius: 8 }} />
  </Box>
);

type SubscriptionPermissionsNavSkeletonProps = {
  rows?: number;
};

/** Nested / main Security nav placeholders while entitlements load. */
export const SubscriptionPermissionsNavSkeleton: FC<SubscriptionPermissionsNavSkeletonProps> = ({
  rows = 6,
}) => (
  <Box px={2} display="flex" flexDirection="column" style={{ gap: 8 }} aria-busy="true">
    {Array.from({ length: rows }, (_, index) => (
      <Skeleton
        key={index}
        variant="rectangular"
        height={36}
        style={{ borderRadius: 6 }}
      />
    ))}
  </Box>
);
